import { getBaseUrl } from '../utils/getBaseUrl'; 

const baseURL = getBaseUrl() + 'media/';

export const DeleteMedia = async (mediaId) => {
    try {
        await fetch(baseURL + 'delete', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: mediaId
        });
        return "Media deleted";
    } catch (error) {
        console.error('Error deleting the Media:', error);
    }
};

export const GetAllMedia = async () => {
    try {
        const response = await fetch(baseURL + 'getall', {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });
        const jsonData = await response.json();
        return jsonData;            
    } catch (error) {
        console.error('Error fetching all media:', error);
    }
};

export const AddMedia = async (mediaBody) => {
    try {
        await fetch(baseURL + 'add', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: mediaBody
        });
        return "Media added";
    } catch (error) {
        console.error('Error adding media:', error);
    }
};